import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import CompanyService from "../../../services/CompanyService";
import { TranslationService } from "../../../services/TranslationService";
import { ProfileData } from "./ProfileData";

export const DataPersonal = () => {
    const location = useLocation();
    const versionAllowed = CompanyService.getVersionAllowed();
    const allowGoV1 = versionAllowed !== 2;

    const linkToV1 = useMemo(() => {
        const baseUrl = `https://www1.intiza.com/account/logontoken?token=${CompanyService.getCompanyAuth()?.companyToken}`
        // process.env.REACT_APP_BASE_SITE_v1 + `account/logontoken?token=${CompanyService.getCompanyAuth()?.companyToken}`

        const returnUrl = location.pathname + location.search;
        return returnUrl ? baseUrl + '&' + returnUrl : baseUrl;
    }, [location.pathname, location.search])



    return (
        <div className="main-layout-container mx-3">
            <div className="main-panel">

                <ProfileData />

                <div className="card mt-4">
                    <div className="d-flex justify-content-end gap-5 align align-items-center ">

                        {allowGoV1 ? <a href={linkToV1} className="d-flex align-items-center pointer">
                            <i className="far fa-clock menu-item-icon"></i>
                            <p className="menu-item-icon-text ">{TranslationService.translate.BackToV1}</p>
                        </a> : null}
                        <Link
                            className="d-flex align-items-center pointer"
                            to={`/${TranslationService.currentLanguage}/logout`}
                        >
                            <i className="far fa-sign-out menu-item-icon"></i>
                            <p className="menu-item-icon-text ">{TranslationService.translate.Logout}</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};